import React from "react";
import styles from "./index.module.less";
import BaseCard from "../components/BaseCard";
import notFoundNetwork from "@/assets/img/thirdApp/icon-not-network.png";

function OfflineCard() {
  return (
    <BaseCard className={styles["content"]}>
      <div>
        <img src={notFoundNetwork} />
        <div>暂无网络</div>
      </div>
    </BaseCard>
  );
}

export default OfflineCard;
